<template>
  <div class="page-wrapper">
    <div class="header-title">交货数据表</div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        row-key="id"
      >
        <el-table-column
          prop="category"
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="right"
              width="400"
              trigger="hover">
              <el-table 
                :data="category"
                size="mini"
                border
              >
                <el-table-column
                  prop="name"
                  label="选项"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="info"
                  label="说明"
                ></el-table-column>
              </el-table>
              <div slot="reference" class="cell" style="cursor: pointer">类别 <i class="el-icon-info"></i></div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.category}}</span>
            <el-select v-else v-model="editForm.category" placeholder="请选择" size="small">
              <el-option
                v-for="item in category"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
            <!-- <el-input
              v-else
              size="small"
              placeholder="请输入类别"
              v-model="editForm.category"
            ></el-input> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="款号"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.model}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入款号"
              v-model="editForm.model"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key1"
          :label="key1Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key1}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key1"
              @input="value => inputNumber(value, 'key1')"
              @blur="value => blurNumber(value, 'key1')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key2"
          :label="key2Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key2}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key2"
              @input="value => inputNumber(value, 'key2')"
              @blur="value => blurNumber(value, 'key2')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key3"
          :label="key3Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key3}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key3"
              @input="value => inputNumber(value, 'key3')"
              @blur="value => blurNumber(value, 'key3')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key4"
          :label="key4Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key4}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key4"
              @input="value => inputNumber(value, 'key4')"
              @blur="value => blurNumber(value, 'key4')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key5"
          :label="key5Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key5}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key5"
              @input="value => inputNumber(value, 'key5')"
              @blur="value => blurNumber(value, 'key5')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key6"
          :label="key6Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key6}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key6"
              @input="value => inputNumber(value, 'key6')"
              @blur="value => blurNumber(value, 'key6')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key7"
          :label="key7Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key7}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key7"
              @input="value => inputNumber(value, 'key7')"
              @blur="value => blurNumber(value, 'key7')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key8"
          :label="key8Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key8}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key8"
              @input="value => inputNumber(value, 'key8')"
              @blur="value => blurNumber(value, 'key8')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="key9"
          :label="key9Name"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editId">{{scope.row.key9}}</span>
            <el-input
              v-else
              size="small"
              placeholder="请输入数量"
              v-model="editForm.key9"
              @input="value => inputNumber(value, 'key9')"
              @blur="value => blurNumber(value, 'key9')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <template v-if="scope.row.id !== editId">
              <el-button type="text" @click="editHandle(scope)">编辑</el-button>
              <el-popconfirm
                title="确定删除这条数据吗？"
                @confirm="deleteHandle(scope)"
              >
                <el-button type="text" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
            <template v-else>
              <el-button type="text" @click="saveHandle">保存</el-button>
              <el-button type="text" @click="cancelHandle">取消</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="handle-bar">
        <el-button style="width: 100%; border-style: dashed" icon="el-icon-plus" @click="addHandle">新增</el-button>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import moment from 'moment'
import { nanoid } from 'nanoid'
import { ajaxDatav } from '../../common/request_datav.js'
import { utils } from '../../common/common.js'
import category from './category'
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  data() {
    return {
      category,
      key1Name: moment().subtract(8, 'days').format('MM月DD日'),
      key2Name: moment().subtract(7, 'days').format('MM月DD日'),
      key3Name: moment().subtract(6, 'days').format('MM月DD日'),
      key4Name: moment().subtract(5, 'days').format('MM月DD日'),
      key5Name: moment().subtract(4, 'days').format('MM月DD日'),
      key6Name: moment().subtract(3, 'days').format('MM月DD日'),
      key7Name: moment().subtract(2, 'days').format('MM月DD日'),
      key8Name: moment().subtract(1, 'days').format('MM月DD日'),
      key9Name: moment().format('MM月DD日'),
      tableData: [
        // {
        //   id: 1,
        //   category: '卫衣1',
        //   model: 'Y-DS1011',
        //   key1: 1,
        //   key2: 2,
        //   key3: 3,
        //   key4: 4,
        //   key5: 5,
        //   key6: 6,
        //   key7: 7,
        //   key8: 8,
        //   key9: 9
        // }, 
      ],
      editType: '', // '1' - 新增   '2' - 编辑
      editId: '',
      editIndex: '',
      editForm: {
        category: '',
        model: '',
        key1: '',
        key2: '',
        key3: '',
        key4: '',
        key5: '',
        key6: '',
        key7: '',
        key8: '',
        key9: ''
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 获取列表数据
    getTableData() {
      ajaxDatav.get('/capacity-dashboard-data/list', { type: 2}).then(res => {
        // console.log(res)
        if (res.code === 200) {
          this.tableData = res.data
        }
      }).catch(e => {
        console.error(e)
      })
    },
    // 提交数据
    submitData(submitData) {
      const loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = submitData.map(item => ({
        createBy: this.adminId,
        type: 2,
        category: item.category,
        model: item.model,
        key1: item.key1,
        key2: item.key2,
        key3: item.key3,
        key4: item.key4,
        key5: item.key5,
        key6: item.key6,
        key7: item.key7,
        key8: item.key8,
        key9: item.key9,
      }))
      ajaxDatav.post('/capacity-dashboard-data/saveBatch', params).then(res => {
        // console.log(res)
        if (res.code === 200) {
          this.tableData = [...submitData]
          this.editId = ''
          this.editType = ''
          this.editIndex = ''
          this.editForm = {}
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      }).catch(e => {
        console.error(e)
      }).finally(() => {
        loading.close()
      })
    },
    // 新增
    addHandle() {
      if (this.editId) return this.$message.error('同时只能编辑一行')
      let addId = nanoid()
      this.tableData.push({
        id: addId,
        category: '',
        model: '',
        key1: '',
        key2: '',
        key3: '',
        key4: '',
        key5: '',
        key6: '',
        key7: '',
        key8: '',
        key9: ''
      })
      this.editId = addId
      this.editType = '1'
      this.editIndex = this.tableData.length - 1
    },
    // 编辑
    editHandle(scope) {
      // console.log(scope)
      if (this.editId) return this.$message.error('同时只能编辑一行')
      let {$index, row} = scope
      this.editId = row.id
      this.editType = '2'
      this.editIndex = $index
      this.editForm = {
        category: row.category,
        model: row.model,
        key1: row.key1,
        key2: row.key2,
        key3: row.key3,
        key4: row.key4,
        key5: row.key5,
        key6: row.key6,
        key7: row.key7,
        key8: row.key8,
        key9: row.key9
      }
    },
    // 校验表单
    validateForm() {
      let validateResult = true
      for(let key in this.editForm) {
        if (this.editForm[key] === '') {
          validateResult = false
          break
        }
        // console.log('//////')
      }
      return validateResult
    },
    // 保存
    saveHandle() {
      if (!this.validateForm()) {
        return this.$message.error('请填写完整！')
      }
      let submitData = [...this.tableData]
      submitData[this.editIndex] = {
        ...submitData[this.editIndex],
        ...this.editForm
      }
      // console.log('submitData', submitData)
      this.submitData(submitData)
    },
    // 取消编辑（新增）
    cancelHandle() {
      if (this.editType === '1') {
        this.tableData.pop()
      }
      this.editId = ''
      this.editType = ''
      this.editIndex = ''
      this.editForm = {}
    },
    deleteHandle(scope) {
      let { row } = scope
      let submitData = this.tableData.filter(item => item.id !== row.id)
      this.submitData(submitData)
    },
    // 控制库存为整数
    inputNumber(value, key) {
      // console.log(value)
      const reg = /^\d+/
      const match = (value.match(reg)) || ''
      // console.log(match)
      this.editForm[key] = (match && match[0]) || ''
    },
    blurNumber(e, key) {
      if (e.target.value !== '') {
        this.editForm[key] = parseInt(e.target.value) + ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 16px;
  .header-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
    color: #333;
  }
  .table-wrapper {
    padding: 16px;
    background: #fff;
  }
  .handle-bar {
    margin: 16px 0 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/capacity/delivery-list.vue